export const ArrowLeft = ({
  rotate,
  light,
}: {
  rotate?: boolean;
  light?: boolean;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20.003 7.598"
      width="15"
      height="7"
      className={`${rotate ? "rotate-180" : ""} mx-1`}
    >
      <path
        d="M4.37 7.6a20.491 20.491 0 0 0-2.428-2.33A9.11 9.11 0 0 0 0 4.078v-.485a10.223 10.223 0 0 0 2.039-1.287A22.329 22.329 0 0 0 4.394 0h.825a12.557 12.557 0 0 1-2.063 3.253H20v1.068H3.107A15.582 15.582 0 0 1 4.224 5.85a16.436 16.436 0 0 1 .922 1.75Z"
        fill={`${light ? "#ffffff" : "#020203"}`}
      ></path>
    </svg>
  );
};

export default ArrowLeft;
